
import { computed, defineComponent, PropType } from 'vue';
import { DosageTimeRange } from '@/service/models/request/computation/dosage-time-range';
import { DosageSteadyState } from '@/service/models/common/query-dosage/parts/dosage-steady-state';
import GenericDosageChoiceRow from '../common/dosage-choices-rows/GenericDosageChoiceRow.vue';

export default defineComponent({
    components: {
        GenericDosageChoiceRow
    },

    props: {
        dosageTimeRange: {
            type: Object as PropType<DosageTimeRange>,
            required: true,
        },
    },

    setup(props)
    {
        const dosageChoice = computed(() => props.dosageTimeRange.dosage.getInnerDosageChoice());
        const isSteadyState = computed(() => props.dosageTimeRange.dosage.dosageRepeat instanceof DosageSteadyState);

        return {
            dosageChoice,
            isSteadyState,
        };
    },
})
